import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Input from "../../../components/forms-fields/Input";
import { addMemoryBox } from "../../../schemas";
import { useFormik } from "formik";
import Select from 'react-select';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ADMIN_ID, BASE_URL, ADMIN_AUTH_TOKEN, UPLOAD_MEMORY_BOX_FILE, UPDATE_MEMORY_BOX_URL } from "../../../env";
import {
  postRecords,
  catchAsync,
  isSuccess,
  toastSuccessMessages,
  toastErrorMessages,
} from "../../../helper/helper";
import CustomSelect from "../../../components/forms-fields/CustomSelectStaffMembers";
import TextArea from "../../../components/forms-fields/TextArea";
import moment from "moment";
import memoryContent from "../../../assets/images/memoryContent.png";
function EditMemoryBox({ userId, subModalEditCarePlan, carePlanDetail }) {
  // console.log("🚀 ~ EditMemoryBox ~ carePlanDetail:", carePlanDetail)
  const handleShowHideModal = () => {
    subModalEditCarePlan((prevShow) => !prevShow);
  };
  const [isSubmitButtonClicked, setIsSubmitButtonClicked] = useState(false);
  const [isToastEditCarePlans, setIsToastEditCarePlans] = useState(false);
  const [videoSizeError, setVideoSizeError] = useState(false)
  const [isStaffId, setIsStaffId] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [uploadedFilePath, setUploadedFilePath] = useState(carePlanDetail?.filePath);

  const [suFormData, setSuFormData] = useState({
    memoryBoxId: carePlanDetail?._id,
    userId: carePlanDetail?.userId?._id,
    addedBy: ADMIN_ID,
    note: carePlanDetail?.note,
    filePath: carePlanDetail?.filePath
  });

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    initialValues: suFormData,
    validationSchema: addMemoryBox,
    onSubmit: async (values) => {
      try {
        

        setIsSubmitButtonClicked(true);
        await postAddCarePlansFormData(values);
      } catch (error) {
        
      }
    },
  });

  const processPostRecords = (method, data) => {
    
    if (data?.status !== isSuccess) {
      setIsToastEditCarePlans(true);
      toastErrorMessages(toast.error, data?.message, "", 500, 500);
      setIsSubmitButtonClicked(false);
      handleShowHideModal();
    } else if (
      method === "postAddCarePlansFormData" &&
      data?.status === isSuccess
    ) {
      setIsToastEditCarePlans(true);
      toastSuccessMessages(toast.success, data?.message, "", 500, 500);
      setIsSubmitButtonClicked(false);
      setTimeout(() => {
        handleShowHideModal();
      }, 2000);
    }
  };

  const postAddCarePlansFormData = catchAsync(async (req, res) => {
    const updateValues = {

      ...values,
      filePath: uploadedFilePath,
      addedBy: ADMIN_ID,
    }
    
    const response = await postRecords(UPDATE_MEMORY_BOX_URL, updateValues);
    
    setIsSubmitButtonClicked(false);
    processPostRecords("postAddCarePlansFormData", response);
  });



  const handleInputChangePrevFields = (e) => {
    handleChange(e);
    handleBlur(e);
  };

  const handleImageChange = async (e) => {
    setIsSubmitButtonClicked(true);
    try {
      const file = e.target.files[0];
      const fileType = file.type;
      const fileSize = file.size;
      // console.log("🚀 ~ handleVideoUpload ~ fileSize:", fileSize)
      // Validate file size (5MB = 1,048,576 bytes)
      if (fileSize > 5 * 1024 * 1024) {
        alert('File size exceeds 5MB');
        setVideoSizeError(true)
        setIsSubmitButtonClicked(false);
        return;
      }

      // Validate file type
      if (
        fileType === 'image/jpeg' ||
        fileType === 'image/png' ||
        fileType === 'image/jpg' ||
        fileType === 'video/mp4' ||
        fileType === 'video/avi' ||
        fileType === 'video/mov' ||
        fileType === 'video/wmv' ||
        fileType === 'video/flv' ||
        fileType === 'video/webm' ||
        fileType === 'video/mkv' ||
        fileType === 'video/quicktime' // Add additional video formats as needed
      ) {
        const fileData = new FormData();
        fileData.append('file', file);
        const apiResponse = await fetch(UPLOAD_MEMORY_BOX_FILE, {
          method: "POST",
          body: fileData,
          headers: {
            Authorization: `Bearer ${ADMIN_AUTH_TOKEN}`,
          },
        });
        const resultResponse = await apiResponse.json();
        setUploadedFilePath(resultResponse?.data);
        
      } else {
        // Unsupported file format
        alert('Unsupported file format');
      }
      setIsSubmitButtonClicked(false);
    } catch (error) {
      console.error("Error uploading file:", error);
      setIsSubmitButtonClicked(false);
    }
  };
  return (
    <>
      <div className="incidents consentCapacityAddNew">
        <form onSubmit={handleSubmit}>
          <div className="formBlockContent">
            <div className="row">
              <div className="col-md-12">
                <div className="memoryBoxContent">
                  <div className="imageBox text-center">
                    <label htmlFor="profilePicture" className="upload-icon">
                      <div className="avatarAction">
                        {uploadedFilePath !== '' && (
                          <>
                            {uploadedFilePath.match(/\.(jpeg|jpg|png|gif)$/i) ? (
                              <img
                                src={`${BASE_URL}${uploadedFilePath}`}
                                alt="Memory Box"
                                style={{ cursor: "pointer" }}
                              />
                            ) : (
                              <video
                                controls
                                src={`${BASE_URL}${uploadedFilePath}`}
                                style={{ cursor: "pointer" }}
                                className="videoMemoryBox"
                              />
                            )}
                          </>
                        )}
                      </div>
                    </label>
                  </div>
                </div>
                <div className="form-group">
                  <input
                    name="fileName"
                    id="fileName"
                    type="file"
                    accept="image/*, video/*,"
                    onChange={handleImageChange}
                  />
                  {
                    videoSizeError ? (
                      <>
                        <div className="validationError">
                          <div className="text-danger">Error: File size exceeds the 5MB limit. Please upload a smaller file.</div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div><p><small>Please upload a file that is 5MB or smaller.</small></p></div>
                      </>
                    )
                  }
                </div>
              </div>
           

              <div className="col-md-12">

                <TextArea
                  id="note"
                  name="note"
                  value={values?.note}
                  onChange={handleInputChangePrevFields}
                  onBlur={handleBlur}
                  labelText="Note Details"
                  rows="3"
                  className="mb-3"
                  customError={touched?.note && errors?.note}
                  errorMessage={errors?.note}
                  erroClass={
                    touched?.note && errors?.note
                      ? "validationError"
                      : ""
                  }
                  requiredStar={true}
                />
              </div>

            </div>
          </div>

          <div className="formActionButtons">
            {isSubmitButtonClicked ? (
              <Button
                onClick={subModalEditCarePlan}
                className="btn-sm"
                variant="primary"
                disabled
              >
                Loading...
              </Button>
            ) : (
              <Button className="btn-sm" variant="primary" type="submit">
                Submit
              </Button>
            )}

            <span
              onClick={subModalEditCarePlan}
              className="btn btn-sm btn-outline-primary"
            >
              Close
            </span>

          </div>
        </form>
      </div>
      {isToastEditCarePlans ? <ToastContainer /> : ''}
    </>
  );
}

export default EditMemoryBox;